/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize Hemoglobin View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './HemoglobinView';

export const mapStateToPropsHemoglobin = mapStateToProps;
export const mapDispatchToPropsHemoglobin = mapDispatchToProps;

export default connect(
  mapStateToPropsHemoglobin,
  mapDispatchToPropsHemoglobin
)(View);
